import Vue from 'vue/dist/vue.esm.js'
import axios from 'axios'
import gsap, { Power2 } from 'gsap'

export class SearchCase {
  static keys = ['robot_cat', 'industry_cat', 'issue_cat']
  constructor() {
    this.el = document.getElementById('vue-case-search')
    const script = document.getElementById('js-case_search')
    if (this.el === null || script === null) return
    axios.get('/wp-json/wp/v2/custom/case').then((res) => {
      this.app = new Vue({
        el: this.el,
        data: {
          posts: res.data,
          robot_cat: vueRobotCats,
          industry_cat: vueIndustryCats,
          issue_cat: vueIssueCats,
          isAccordionOpen: false,
        },
        computed: {
          fixedRobotCats() {
            const parents = this.robot_cat.filter((item) => item.parent === 0)
            const children = this.robot_cat.filter((item) => item.parent !== 0)
            return parents
              .map((parent) => {
                parent.children = children.filter((item) => item.parent === parent.term_id)
                return parent
              })
              .filter(({ children }) => children.length > 0)
          },

          checkedRobotCats() {
            return this.robot_cat.filter((item) => item.checked).map(({ term_id }) => term_id)
          },
          fixedIssueCats() {
            const parents = this.issue_cat.filter((item) => item.parent === 0)
            const children = this.issue_cat.filter((item) => item.parent !== 0)
            return parents
              .map((parent) => {
                parent.children = children.filter((item) => item.parent === parent.term_id)
                return parent
              })
              .filter(({ children }) => children.length > 0)
          },
          checkedIssueCats() {
            return this.issue_cat.filter((item) => item.checked).map(({ term_id }) => term_id)
          },
          checkedIndustryCats() {
            return this.industry_cat.filter((item) => item.checked).map(({ term_id }) => term_id)
          },
          allSomeChecked() {
            return this.checkedRobotCats.length > 0 || this.checkedIndustryCats.length > 0 || this.checkedIssueCats.length > 0
          },
          filteredPosts() {
            return this.allSomeChecked
              ? this.posts.filter(
                  (post) =>
                    post.robot_cat.some((term_id) => this.checkedRobotCats.includes(term_id)) ||
                    post.industry_cat.some((term_id) => this.checkedIndustryCats.includes(term_id)) ||
                    post.issue_cat.some((term_id) => this.checkedIssueCats.includes(term_id))
                )
              : this.posts
          },
          filteredPostsLength() {
            return this.filteredPosts.length
          },
        },
        mounted() {},
        methods: {
          toggleCheck: function (item) {
            item.checked = !item.checked
          },
          toggleAccordion({ currentTarget }) {
            const next = currentTarget.nextElementSibling
            if (next) {
              const nextChild = next.children[0]

              if (nextChild) {
                if (currentTarget.classList.contains('is-open')) {
                  currentTarget.classList.remove('is-open')
                  gsap.fromTo(
                    next,
                    {
                      height: nextChild.clientHeight,
                    },
                    {
                      height: 0,
                      ease: Power2.easeOut,
                      duration: 0.4,
                    }
                  )
                } else {
                  currentTarget.classList.add('is-open')
                  gsap.to(next, {
                    height: nextChild.clientHeight,
                    ease: Power2.easeOut,
                    duration: 0.4,
                    onComplete: () => {
                      next.style.height = 'auto'
                    },
                  })
                }
              }
            }
            // const button = event.currentTarget;
            // const content = button.nextElementSibling;
            // if (content.classList.contains('is-open')) {
            //   content.classList.remove('is-open');
            // } else {
            //   content.classList.add('is-open');
            // }
          },
        },
      })
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          this.reset()
        } else {
          var entries = performance.getEntriesByType('navigation')
          entries.forEach((entry) => {
            if (entry.type == 'back_forward') {
              this.reset()
            }
          })
        }
      })
    })
  }
  reset() {
    const checkBoxes = [...this.el.querySelectorAll('input[type="checkbox"]')]
    SearchCase.keys.forEach((key) => {
      const checkedTerms = this.app[key].filter(({ checked }) => checked).map(({ id }) => String(id))
      const name = key.slice(0, -1) + '[]'
      checkBoxes.forEach((checkBox) => {
        if (checkBox.name === name) {
          checkBox.checked = checkedTerms.includes(checkBox.value)
        }
      })
    })
  }
}
